module.exports = __webpack_public_path__ + "img/map.c42d2465.png";